import React from 'react';
import './Schedule.css';

const Schedule = () => {
  const classes = ['Classe 1', 'Classe 2', 'Classe 3', 'Classe 4'];

  // Sample schedule data - replace with actual data
  const scheduleData = [
    {
      day: 'JOURNEE DU DIMANCHE 02 NOVEMBRE 2025',
      rows: [
        { time: '14:00 - 17:00', common: 'Arrivée, accueil et installation des participant.e.s', intervenants: 'Comité d\'organisation', observations: '' },
        { time: '17:45 - 18:00', common: 'Cérémonie de lancement (1ère partie)', intervenants: '', observations: 'Présentiel- Plénière' },
        { time: '18:00 - 18:10', common: 'Rassemblement et installation des participant.e.s', intervenants: 'Tous les participant.e.s', observations: '' },
        { time: '18:10 - 18:40', common: 'Mots de bienvenue du Comité d\'Organisation', intervenants: 'Point Focal - Camp RYEEB 2025', observations: '' },
        { time: '18:40 - 19:00', common: 'Historique et Vision du Camp des Jeunes et Evaluateurs Emergents Francophones : De la 1ere à la 8 édition. Questions - Réponses', intervenants: 'Concepteur - Coordonnateur du Camp', observations: '' },
        { time: '18:40 - 19:00', common: 'Présentation commentée du programme du Camp Régional des Jeunes et Evaluateurs Emergents Francophone. Questions - Réponses', intervenants: 'Comité Technique et Scientifique du Cam', observations: '' },

        { time: '18:40 - 19:00', common: 'Présentation des membres du Comité d\'Organisation', intervenants: 'Membres du Comité d\'Organisation', observations: '' },
        { time: '18:40 - 19:00', common: 'Parole aux formateurs et facilitateurs', intervenants: 'Le Collège des Formateurs et leurs Assistants', observations: '' },
        
        { time: "19:00 - 19:15", common: "Détails logistiques aux participants.Questions - Réponses", intervenants: "Le Collège des Formateurs et leurs Assistants", observations: "" },
        { time: "19:15 - 19:30", common: "Présentation sur le feu du Camp : Bon à savoir", intervenants: "Point Focal - Camp RYEEB 2025", observations: "" },
        
        { time: "19:30 - 19:50", common: "3min pour faire connaissance", intervenants: "Responsable de la Gestion du Feu du Camp", observations: "" },

        { time: '', common: 'Cérémonie de lancement (2e partie)', intervenants: 'Comité d\'organisation et participants', observations: 'Lieu du feu de Camp' },

        { time: "19:50 - 20:00", common: "Accueil et mise en place sur les lieux du feu du Camp (En plein air autour du feu)", intervenants: "Comité d'organisation et participants", observations: "" },

        { time: "20:00 - 20:10", common: "Allumage du feu du Camp des Evaluateurs Emergents Francophones", intervenants: "Tous les participants", observations: "" },
        { time: "20:10 - 20:15", common: "Exécution solennelle de l'hymne du Camp ;", intervenants: "Responsable de la Gestion du Feu du Camp", observations: "" },
        { time: "20:15 - 21:00", common: "Présentation individuelle de chaque participant et serment", intervenants: "Tous les participants", observations: "" },
        { time: "21:00 - 21:15", common: "Animation autour du feu de Camp", intervenants: "Tous les participants - Chanson de chaque pays", observations: "" },

        { time: '', common: 'Cérémonie de lancement (3e partie)', intervenants: 'Comité d\'organisation et participants', observations: '' },

        { time: "21:15 - 21:30", common: "Accueil et mise en place pour le dîner d'accueil du Camp", intervenants: "Comité d'organisation et participants", observations: "Réfectoire" },
        { time: "21:30 - 22:30", common: "Dîner d'accueil des participants", intervenants: "Tous les participants", observations: "" },
        { time: "22:30 - 23:00", common: "Fin du dîner et Quartier libre", intervenants: "Comité d'organisation et participants", observations: "" },
        { time: "23:00", common: "Couvre-feu et fin de journée", intervenants: "", observations: "" }
      ]
    },
    {
      day: 'JOURNEE DU LUNDI 03 NOVEMBRE 2025',
      rows: [
      { time: "08:00 - 08:30", common: "Arrivée, accueil et installation des participants", intervenants: "Participant.e.s / Comité d'organisation", observations: "Présentiel-Plénière" },
      { time: "08:30 - 09:00", common: "Recap des images de la veille", intervenants: "Equipe de communication", observations: "Présentiel-Plénière" },
      { time: "09:00 - 09:10", common: "Adresse Introductive et programme de la journée", intervenants: "Comité d'organisation (Binôme du jour)", observations: "Présentiel-Plénière" },

      { time: "", common: "TEST DE NIVEAU INITIAL", intervenants: "En ligne dans le processus préparatif", observations: "En ligne et avant d'arrivée au Camp" },

      { time: "09:10 - 10:30", common: "Module 1 (Part 1) - Cours: Parcours méthodo 360°", intervenants: "Prof Caroline BRASSARD & Ir.MSc. Deo-Gracias HOUNDOLO", observations: "" },
      
      { time: "10:30 - 11:00", common: "Pause-café et interactions", intervenants: "", observations: "" },
      
      { time: "11:00 - 12:15", common: "Module 1 (Part 2) - Cours: Parcours méthodo 360°", intervenants: "Ir.MSc. Deo-Gracias HOUNDOLO & Prof Caroline BRASSARD", observations: "" },
      
      { time: "12:15 - 13:00", classes: ['  ','Module 1 (Part 3) - Travaux de groupe/Pratique:Parcours méthodo 360° en Formulation Analyse etEvaluation des Politiques Publiques pour la prise de décisions éclairée par les données probantes (EIDM)','Module 1 (Part 3) - Travaux de groupe/Pratique:Parcours méthodo 360° en Formulation Analyse etEvaluation des Politiques Publiques pour la prise de décisions éclairée par les données probantes (EIDM)','Module 1 (Part 3) - Travaux de groupe/Pratique:Parcours méthodo 360° en Formulation Analyse etEvaluation des Politiques Publiques pour la prise de décisions éclairée par les données probantes (EIDM)'], intervenants: "Ir.MSc. Deo-Gracias HOUNDOLO, Prof Mathieu Ouimet, Dr Hamdy Bonou-Gbo, Dr Hervé B.M. GBENAHOU, Prof Caroline BRASSARD, Mr Aziz KANE, Dr Plinio LIMATA & Dr Nouréini", observations: "" },
      
      
      { time: "13:00 - 14:00", common: "Pause déjeuner", intervenants: "", observations: "" },
      

      { time: "14:00 - 14:30", common: "Regroupement et orientations pour les travaux de terrain (groupe en fonction des choix de salle 2, salle 3 ou salle 4)", intervenants: "Responsable de la Gestion des Travaux de terrain - Comité d'organisation", observations: "" },

      { time: "14:30 - 15:00", common: "Mise en route vers les sites de terrain", intervenants: "Responsable de la Gestion des Travaux de terrain - Comité d'organisation", observations: "" },
      
      { time: "15:00 - 17:30", common: "Travaux de terrain: immersion en milieu réel", intervenants: "Responsable de la Gestion des Travaux de terrain - Comité d'organisation", observations: "" },
      
      { time: "17:30 - 18:00", common: "Retour du terrain", intervenants: "Responsable de la Gestion des Travaux de terrain - Comité d'organisation", observations: "" },
      
      { time: "18:00 - 20:00", common: "Pause - Organisation interne des groupes - Dîner libre", intervenants: "Participant.e.s - Appui du collège des formateurs", observations: "" },
      
      { time: "20:00 - 22:00", common: "Travaux de groupe et facilitation des formateurs", intervenants: "Participant.e.s - Appui du collège des formateurs", observations: "" },
      
      { time: "22:00", common: "Quartier libre et fin de journée", intervenants: "Participant.e.s - Appui du Comité d'Organisation", observations: "" }
    ]
    },
    {
      day: 'JOURNEE DU MARDI 04 NOVEMBRE 2025',
      rows: [
      { time: "08:00 - 08:30", common: "Arrivée, accueil et installation des participants", intervenants: "Formateurs et participants", observations: "Présentiel-Plénière" },
      { time: "08:30 - 09:00", common: "Recap des images de la veille", intervenants: "Equipe de communication", observations: "Présentiel-Plénière" },
      { time: "09:00 - 09:10", common: "Adresse Introductive et programme de la journée", intervenants: "Comité d'organisation (Binôme du jour)", observations: "Présentiel-Plénière" },
      { time: "09:10 - 10:00", common: "Restitution des travaux de groupe", intervenants: "Formateurs et participants", observations: "Présentiel-Plénière" },
      
      { time: "10:00 - 10:30", common: "Pause-café et interactions", intervenants: "", observations: "" },
      
      { time: "10:30 - 13:00", classes: ["Formation en salles parallèles",
        "Salle 2: Introduction aux Méthodes d'évaluation d'impact expérimentales et quasi-expérimentales des Politiques Programmes et Projets", 
        "Salle 3: Introduction aux méthodes qualitatives en Formulation Analyse et Evaluation des Politiques Programmes et Projets", 
        "Salle 4: Introduction aux méthodes de vignette en évaluation des Politiques Programmes et Projets"], intervenants: "Ir.MSc. Deo-Gracias HOUNDOLO, Prof Mathieu Ouimet, Dr Hamdy Bonou-Gbo, Dr Hervé B.M. GBENAHOU, Prof Caroline BRASSARD, Mr Aziz KANE, Dr Plinio LIMATA & Dr Nouréini", observations: "" },

      { time: "13:00 - 14:00", common: "Pause déjeuner", intervenants: "", observations: "" },
      
      { time: "14:00 - 14:30", common: "Regroupement en salles parallèles et orientations", intervenants: "Ir.MSc. Deo-Gracias HOUNDOLO, Prof Mathieu Ouimet, Dr Hamdy Bonou-Gbo, Dr Hervé B.M. GBENAHOU, Prof Caroline BRASSARD, Mr Aziz KANE, Dr Plinio LIMATA & Dr Nouréini", observations: "" },

      { time: "14:30 - 15:00", common: "Mise en route des groupes pour arriver sur les sites des travaux de terrain", intervenants: "Responsable de la Gestion des Travaux de terrain - Comité d'organisation", observations: "" },

      { time: "15:00 - 17:30", common: "Déroulement des travaux de terrain en groupe: Collecte de données pour analyse et évaluation des Politiques Programmes et Projets suivant différentes méthodes (consignes des salle 2, salle 3 et salle 4)", intervenants: "Responsable de la Gestion des Travaux de terrain - Comité d'organisation", observations: "" },

      { time: "17:30 - 18:00", common: "Retour du terrain", intervenants: "Responsable de la Gestion des Travaux de terrain - Comité d'organisation", observations: "" },
      
      { time: "18:00 - 20:00", common: "Pause - Organisation interne des groupes - Dîner libre", intervenants: "Participant.e.s - Appui du collège des formateurs", observations: "" },
      
      { time: "20:00 - 22:00", common: "Travaux de groupe et facilitation des formateurs", intervenants: "Participant.e.s - Appui du collège des formateurs", observations: "" },
      
      { time: "22:00", common: "Quartier libre et fin de journée", intervenants: "", observations: "" }
    ]
    },
    {
      day: 'JOURNEE DU MERCREDI 05 NOVEMBRE 2025',
      rows: [
      { time: "08:00 - 08:30", common: "Arrivée, accueil et installation des participants", intervenants: "Formateurs et participants", observations: "Présentiel-Plénière" },
      
      { time: "08:30 - 09:00", common: "Recap des images de la veille", intervenants: "Equipe de communication", observations: "Présentiel-Plénière" },
      
      { time: "09:00 - 09:10", common: "Adresse Introductive", intervenants: "Point focal", observations: "Présentiel-Plénière" },
      
      { time: "09:10 - 10:30", common: "Qualité des Données Probantes - Utilisabilité des Synthèses et Conseil Scientifique (Part 1)", intervenants: "Prof Mathieu Ouimet", observations: "Présentiel-Plénière" },
      
      { time: "10:30 - 11:00", common: "Pause-café et interactions", intervenants: "", observations: "" },
      
      { time: "11:00 - 13:00", common: "Qualité des Données Probantes - Utilisabilité des Synthèses et Conseil Scientifique (Suite et fin)", intervenants: "Prof Mathieu Ouimet", observations: "Présentiel-Plénière" },
      
      { time: "13:00 - 14:00", common: "Pause déjeuner", intervenants: "", observations: "" },
      
      { time: "14:00 - 16:00", common: "Leadership et Evaluation : Les compétences transversales au-delà des capacités techniques (Part1)", intervenants: "", observations: "" },
      
      { time: "16:00 - 16:30", common: "Pause-café et interactions", intervenants: "", observations: "" },
      
      { time: "16:30 - 17:30", common: "Leadership et Evaluation : Les compétences transversales au-delà des capacités techniques (Suite et fin)", intervenants: "", observations: "" },
      
      { time: "17:30 - 19:00", common: "Pause - Rafraîchissement libre", intervenants: "", observations: "" },
      
      { time: "19:00 - 20:30", common: "Echange intergénérationnel : Ubuntu et à bâton rompu", intervenants: "", observations: "" },
      
      { time: "20:30 - 22:00", common: "Dîner libre - Quartier libre - Fin de journée", intervenants: "", observations: "" }
    ]
    },
    {
      day: 'JOURNEE DU JEUDI 06 NOVEMBRE 2025',
      rows: [
      { time: "08:00 - 08:30", common: "Arrivée, accueil et installation des participants", intervenants: "Formateurs et participants", observations: "Présentiel-Plénière" },
      { time: "08:30 - 09:00", common: "Recap des images de la veille", intervenants: "Equipe de communication", observations: "Présentiel-Plénière" },
      { time: "09:00 - 09:10", common: "Adresse Introductive", intervenants: "Point focal", observations: "Présentiel-Plénière" },

      { time: "09:15 - 10:00", classes: [
        "Introduction aux méthodes qualitatives Restitution des travaux de groupe (terrain) du mardi",
        "Salle 2: Introduction aux Méthodes d'évaluation d'impact Restitution des travaux de groupe (terrain) du mardi", 
        "Salle 3: Introduction aux méthodes qualitatives Restitution des travaux de groupe (terrain) du mardi", 
        "Salle 4: Introduction aux méthodes de vignette Restitution des travaux de groupe (terrain) du mardi"], intervenants: "", observations: "" },

      { time: "10:00 - 10:30", classes: [
        "",
        "Salle 2: Introduction aux Méthodes d'évaluation d'impact Comprendre le développement des outils de collecte de données : cas des questionnaires en pratique (de la Théorie de changement au cadre logique pour venir aux outils)", 
        "Salle 3: Salle 3: Introduction aux méthodes qualitatives Comprendre le développement des outils de collecte de données : cas des guide d'entretien en pratique (de la Théorie de changement au cadre logique pour venir aux outils)", 
        "Salle 4: Introduction aux méthodes de vignette Comprendre le développement des outils de collecte de données pour la vignette : cas des des questionnaires en pratique (de la Théorie de changement au cadre logique pour venir aux outils)"],
         intervenants: "", observations: "" },
      
      { time: "10:30 - 11:00", common: "Pause-café et interactions", intervenants: "Formateurs et participants", observations: "Présentiel-Plénière" },
      
      { time: "11:00 - 13:00", classes: ["Salle 2: Développement outils de collecte - questionnaires", "Salle 3: Développement outils de collecte - guides d'entretien", "Salle 4: Développement outils de collecte - vignettes"], intervenants: "", observations: "" },
      
      { time: "13:00 - 14:00", common: "Pause déjeuner", intervenants: "", observations: "" },
      
      { time: "14:00 - 16:00", classes: ["Salle 2: Analyse données quantitatives d'impact", "Salle 3: Analyse données qualitatives", "Salle 4: Analyse données avec vignettes"], intervenants: "", observations: "" },
      
      { time: "16:00 - 16:30", common: "Pause-café et interactions", intervenants: "", observations: "" },
      { time: "16:30 - 17:30", common: "Les critères d'évaluation sensibles à l'enfance et à l'adolescence", intervenants: "", observations: "" },
      { time: "17:30 - 19:00", common: "Pause - Rafraîchissement libre", intervenants: "", observations: "" },
      { time: "19:00 - 20:30", common: "Parole aux participants: Sous les feux de la rampe - présentation de projets personnels", intervenants: "", observations: "" },
      { time: "20:30 - 22:00", common: "Dîner libre - Quartier libre - Fin de journée", intervenants: "", observations: "" }
        
    ]
    },
    {
    day: "JOURNEE DU VENDREDI 07 NOVEMBRE 2025",
    rows: [
      { time: "08:00 - 08:30", common: "Arrivée, accueil et installation des participants", intervenants: "Formateurs et participants", observations: "Présentiel-Plénière" },
      { time: "08:30 - 09:00", common: "Recap des images de la veille", intervenants: "Equipe de communication", observations: "Présentiel-Plénière" },
      { time: "09:00 - 09:10", common: "Adresse Introductive", intervenants: "Point focal", observations: "Présentiel-Plénière" },
      { time: "09:10 - 10:30", common: "Place de l'Intelligence Artificielle dans le processus d'évaluations", intervenants: "DGE/MDCAG (Bénin)", observations: "Présentiel-Plénière" },
      { time: "10:30 - 11:00", common: "Pause café", intervenants: "", observations: "" },
      { time: "11:00 - 11:30", common: "Présentation du Centre d'Incubation de Recherche et d'Innovation du Baromètre", intervenants: "", observations: "" },
      { time: "11:30 - 13:00", common: "Présentation de solutions du Centre d'Incubation", intervenants: "", observations: "" },
      { time: "13:00 - 14:00", common: "Pause déjeuner", intervenants: "", observations: "" },
      { time: "14:00 - 15:00", common: "Le QUIZ DU CAMP : Evaluation générale des acquis", intervenants: "Formateurs", observations: "Présentiel-Plénière" },
      { time: "15:00 - 16:00", common: "Cérémonie de clôture", intervenants: "Ministère du Développement et la Coordination, Le Baromètre, PÉTÉ, ARCS, etc.", observations: "Présentiel-Plénière" },
      { time: "16:00 - 18:00", common: "À la découverte de la ville de Dassa-Zoumé", intervenants: "", observations: "" },
      { time: "18:00 - 20:00", common: "Quartier libre - Clôture de la journée", intervenants: "", observations: "" }
    ]
  },
  {
    day: "JOURNEE DU SAMEDI 08 NOVEMBRE 2025",
    rows: [
      { time: "08:00 - 12:00", common: "Départ des délégations : à la découverte touristique de la ville de Dassa-Zoumé", intervenants: "Comité d'Organisation et Collège des Formateurs", observations: "" },
      { time: "12:00 - 14:00", common: "Départ des dernières délégations et couvre-feu", intervenants: "", observations: "Fin du Camp" }
    ]
  }




  ];

  return (
    <div className="schedule">
      <h2>Programme des Formations</h2>
      <div className="class-descriptions">
        <div className="class-desc">
          <h3>Salle 1 : Plénière</h3>
          <p>Parcours méthodo 360° en Formulation Analyse et Evaluation des Politiques Publiques pour la prise de décisions éclairée par les données probantes (EIDM)</p>
        </div>
        <div className="class-desc">
          <h3>Salle 2 :</h3>
          <p>Introduction aux Méthodes d'évaluation d'impact expérimentales et quasi-expérimentales des Politiques Programmes et Projets</p>
        </div>
        <div className="class-desc">
          <h3>Salle 3 :</h3>
          <p>Introduction aux méthodes qualitatives en Formulation Analyse et Evaluation des Politiques Programmes et Projets</p>
        </div>
        <div className="class-desc">
          <h3>Salle 4 :</h3>
          <p>Introduction aux méthodes de vignette en évaluation des Politiques Programmes et Projets</p>
        </div>
      </div>
      <div className="table-container">
        <table className="schedule-table">
          {/* Fix table header */}
        <thead >
          <tr>
            <th>Horaire</th>
            {classes.map(cls => <th key={cls}>{cls}</th>)}
            <th>Intervenants</th>
            <th>Observations</th>
          </tr>
        </thead>
        <tbody>
          {scheduleData.map((dayData, dayIndex) => (
            <React.Fragment key={dayIndex}>
              <tr>
                <td colSpan={classes.length + 3} className="day-header">{dayData.day}</td>
              </tr>
              {dayData.rows.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td className="time-cell">{row.time}</td>
                  {row.common ? (
                    <>
                      <td colSpan={classes.length} className="common-cell">{row.common}</td>
                      <td className="intervenant-cell">{row.intervenants}</td>
                      <td className="observation-cell">{row.observations}</td>
                    </>
                  ) : (
                    <>
                      {row.classes.map((activity, idx) => (
                        <td key={idx} className="activity-cell">{activity}</td>
                      ))}
                      <td className="intervenant-cell">{row.intervenants}</td>
                      <td className="observation-cell">{row.observations}</td>
                    </>
                  )}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default Schedule;